import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-template-skeleton',
  templateUrl: './search-template-skeleton.component.html',
  styleUrls: ['./search-template-skeleton.component.scss'],
  standalone: false
})
export class SearchTemplateSkeletonComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
